import { DiagnosisModel, IDiagnosisModel } from '@common/models/DiagnosisModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class DiagnosisService {
  private static baseUrl: string = '/api/diagnosis';

  static tags = {
    upsertDiagnosis: 'upsertDiagnosis',
    deleteDiagnosis: 'deleteDiagnosis',
  };

  static upsertDiagnosis = (
    data: IDiagnosisModel,
    options?: ServiceMethodOptions,
  ): Promise<DiagnosisModel> => {
    return trackPromise(
      new Promise<IDiagnosisModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IDiagnosisModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Diagnosis updated', options);
            resolve(new DiagnosisModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Diagnosis', options);
            reject(err);
          });
      }),
      this.tags.upsertDiagnosis,
    );
  };

  static deleteDiagnosis = (
    diagnosisId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${diagnosisId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Diagnosis has been deleted', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Diagnosis', options);
            reject(err);
          });
      }),
      this.tags.deleteDiagnosis,
    );
  };
}
